module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-500.cea99d3.woff";